import React from 'react';
import { Image } from 'expo-image';
import { VStack } from 'native-base';
import { BlurView } from 'expo-blur';

// Redux
import { useAppDispatch, flipToPane } from '@breakroom-nx/redux';

// Components
import { PrimaryButton, SecondaryButton, TertiaryButton } from '../../';

// Assets & Helpers
import logoImage from '../../../../assets/src/images/logo.webp';

import { EyeOffIcon as AnonIcon } from 'react-native-heroicons/solid';
import { AppData } from '@breakroom-nx/helpers';

export function WelcomePanel() {
  // Redux
  const dispatch = useAppDispatch();

  return (
    <>
      <VStack mb={'10%'} alignItems={'center'}>
        <Image
          source={{ uri: logoImage }}
          cachePolicy={'memory-disk'}
          accessibilityLabel={`${AppData.APP_NAME} logo`}
          contentFit={'contain'}
          style={{
            width: '40%',
            aspectRatio: 1,
          }}
        />
      </VStack>
      <VStack space={4} mb={5}>
        <PrimaryButton
          text={'Sign Up'}
          onPress={() => {
            dispatch(flipToPane('Signup'));
          }}
        />
        <BlurView
          intensity={35}
          style={{ borderRadius: 50, overflow: 'hidden' }}
        >
          <SecondaryButton
            bg={'transparent'}
            onPress={() => {
              dispatch(flipToPane('Login'));
            }}
            text={'Login'}
          />
        </BlurView>
        <TertiaryButton
          color={'white'}
          text={'Browse anonymously'}
          onPress={() => {
            dispatch(flipToPane('Anonymous'));
          }}
          startIcon={<AnonIcon size={17} color={'white'} />}
          style={{
            marginTop: '10px',
          }}
        />
      </VStack>
    </>
  );
}

export default React.memo(WelcomePanel);
